import { portalColors, portalRadius } from './portalStyles';

export type PortalTab = 'today' | 'week' | 'month';

interface Props {
  activeTab: PortalTab;
  onTabChange: (tab: PortalTab) => void;
}

const TABS: { key: PortalTab; label: string }[] = [
  { key: 'today', label: 'Today' },
  { key: 'week', label: 'This week' },
  { key: 'month', label: 'This month' },
];

export function PortalTabs({ activeTab, onTabChange }: Props) {
  return (
    <div style={{
      display: 'flex', background: portalColors.divider,
      borderRadius: portalRadius.tab, padding: 3, marginBottom: 20,
    }}>
      {TABS.map(t => {
        const active = activeTab === t.key;
        return (
          <button
            key={t.key}
            onClick={() => onTabChange(t.key)}
            style={{
              flex: 1, padding: '8px 0', border: 'none', cursor: 'pointer',
              borderRadius: 8, fontSize: 14, fontWeight: active ? 500 : 400,
              fontFamily: 'inherit',
              background: active ? portalColors.card : 'transparent',
              color: active ? portalColors.primary : portalColors.secondary,
              boxShadow: active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
              transition: 'background 200ms, color 200ms',
            }}
          >{t.label}</button>
        );
      })}
    </div>
  );
}
